import { render, staticRenderFns } from "./ChooseHolder.vue?vue&type=template&id=d8bc77d8&"
import script from "./ChooseHolder.vue?vue&type=script&lang=js&"
export * from "./ChooseHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports